import { useState, useEffect } from "react"

const SESSION_KEY = "donation_popup_session"

export const UseSessionPopup = (delay = 1000) => {
  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    // Check if this is a new session (not navigation within the site)
    const isNewSession = !sessionStorage.getItem(SESSION_KEY)

    if (isNewSession) {
      // Mark this session
      sessionStorage.setItem(SESSION_KEY, "true")

      // // Show popup after delay
      // const timer = setTimeout(() => {
      //   setShowPopup(true)
      // }, delay)

      // return () => clearTimeout(timer)
    }
  }, [delay])

  const closePopup = () => {
    setShowPopup(false)
  }

  return { showPopup, closePopup, setShowPopup }
}
